import { createApiInstance, API_BASE_URL } from './axiosConfig';

export interface ImageInfo {
  filename: string;
  size: number;
  url: string;
}

export interface UploadResponse {
  filename: string;
  url: string;
}

export class ImageService {
  private api = createApiInstance(`${API_BASE_URL}/images`);

  setAuthToken(token: string): void {
    this.api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  removeAuthToken(): void {
    delete this.api.defaults.headers.common['Authorization'];
  }

  async getImages(): Promise<string[]> {
    const response = await this.api.get('/');
    return response.data;
  }

  async uploadImage(file: File): Promise<UploadResponse> {
    const formData = new FormData();
    formData.append('image', file);

    const response = await this.api.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async deleteImage(filename: string): Promise<void> {
    await this.api.delete(`/${filename}`);
  }

  async getImageInfo(filename: string): Promise<ImageInfo> {
    const response = await this.api.get(`/${filename}/info`);
    return response.data;
  }

  getImageUrl(filename: string): string {
    return `/assets/images/${filename}`;
  }
}
